import { Button, useTranslation } from '@helios/frontend-core';


interface FilterModalButtonsProps {
  trackingIdPrefix: string;
  onApply: () => void;
  onRemove: () => void;
}

export const FilterModalButtons = ({ trackingIdPrefix, onApply, onRemove }: FilterModalButtonsProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex gap-12 pt-16">
      <Button emphasis="secondary" trackingId={`${trackingIdPrefix}-remove`} onClick={onRemove}>
        {t('shopSearch.productFilters.removeFilter')}
      </Button>
      <Button trackingId={`${trackingIdPrefix}-apply`} onClick={onApply}>
        {t('shopSearch.productFilters.filterProducts')}
      </Button>
    </div>
  );
};

interface FilterBottomSheetButtonsProps extends FilterModalButtonsProps {
  onDismiss: () => void;
}

export const FilterBottomSheetButtons = ({
  trackingIdPrefix,
  onApply,
  onRemove,
  onDismiss,
}: FilterBottomSheetButtonsProps) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-12">
      <Button trackingId={`apply-${trackingIdPrefix}`} onClick={onApply}>
        {t('shopSearch.productFilters.filterProducts')}
      </Button>
      <Button emphasis="secondary" trackingId={`remove-${trackingIdPrefix}`} onClick={onRemove}>
        {t('shopSearch.productFilters.removeFilter')}
      </Button>
      <Button emphasis="tertiary" trackingId={`cancel-${trackingIdPrefix}`} onClick={onDismiss}>
        {t('common.cancel')}
      </Button>
    </div>
  );
};
